import React from "react";
import type { RouteObject } from "react-router-dom";
import WithdrawResume from "../pages/WithdrawResume";
import Anticipation from "../pages/Anticipation";
import AuthorizationInquiryBalance from "../pages/AuthorizationInquiryBalance";
import ConnectFGTSBalance from "../pages/ConnectFGTSBalance";
import ContractViewer from "../pages/ContractViewer";
import AnniversaryMembershipEgress from "../pages/Feedbacks/AnniversaryMembershipEgress";
import CaixaError from "../pages/Feedbacks/CaixaError";
import InexistentAnniversaryMembership from "../pages/Feedbacks/InexistentAnniversaryMembership";
import OnLockedDateRange from "../pages/Feedbacks/OnLockedDateRange";
import OngoingOperation from "../pages/Feedbacks/OngoingOperation";
import ProcessingPendingChanges from "../pages/Feedbacks/ProcessingPendingChanges";
import UnauthorizedInstitution from "../pages/Feedbacks/UnauthorizedInstitution";
import UnavailableRealTime from "../pages/Feedbacks/UnavailableRealTime";
import Home from "../pages/Home";
import HowToAuthorize from "../pages/HowToAuthorize";
import SimulatorLead from "../pages/SimulatorLead";
import SimulatorResume from "../pages/SimulatorResume";
import SimulatorSummary from "../pages/SimulatorSummary";
import ProtectedRoute from "./protectedRoute";
import WithdrawPaymentInfo from "../pages/WithdrawPaymentInfo";
import Authentication from "../pages/Authentication";
import AccessBlocked from "../pages/AccessBlocked";
import SystemUnavailable from "../pages/SystemUnavailable";
import SystemMaintenance from "../pages/SystemMaintenance";
import PasswordReset from "../pages/SignContract/ForgotPassword/PasswordReset";
import PasswordChangeSuccess from "../pages/PasswordChangeSuccess";
import SignContract from "../pages/SignContract/SubscriptionPassword";
import AnticipationFinished from "../pages/SignContract/AnticipationFinished";
import RegisterSuccess from "../pages/FintechRegistration/RegisterSuccess";
import ValidateTokenOTPByEmail from "../pages/FintechRegistration/ValidateTokenOTPByEmail";
import PasswordRegistration from "../pages/FintechRegistration/PasswordRegistration";
import UserRegistrationData from "../pages/FintechRegistration/UserRegistrationData";
import PersonalAditionalInfo from "../pages/FintechRegistration/PersonalAditionalInfo";
import AddressInput from "../pages/FintechRegistration/AddressInput";
import ValidateOTPBySMS from "../pages/SignContract/ForgotPassword/ValidateOTPBySMS";
import CustomerRefusal from "../pages/CustomerRefusal";
import ValidateDocumentsHome from "../pages/FintechRegistration/ValidateDocuments/ValidateDocumentsHome";
import ValidateDocumentsUnderAnalysis from "../pages/FintechRegistration/ValidateDocuments/ValidateDocumentsUnderAnalysis";
import ValidateDocumentsApproved from "../pages/FintechRegistration/ValidateDocuments/ValidateDocumentsApproved";
import ValidateDocumentsRefused from "../pages/FintechRegistration/ValidateDocuments/ValidateDocumentsRefused";
import SignInInfo from "../pages/SignInInfo";
import { TermsOfConditions } from "../pages/FintechRegistration/TermsOfConditions";
import ExpiredToken from "../pages/Feedbacks/ExpiredToken";
import { SuccessAlterPassword } from "../pages/SignContract/ForgotPassword/SuccessAlterPassword";
import OnboardingCaf from "../pages/Documents/OnboardingCaf";
import PublicRoute from "./publicRoute";
import HomeLogged from "../pages/HomeLogged";
import CallCenter from "../pages/CallCenter";
import ContractDetails from "../pages/ContractDetails";
import ListOfContracts from "../pages/ListOfContracts";

// Rotas de erros
import ErrorCustomUnavailable from "../pages/Errors/ErrorCustomUnavailable";
import ErrorQueryTimeExpired from "../pages/Errors/ErrorQueryTimeExpired";
import ErrorOpenSettlementWithUpperLimit from "../pages/Errors/ErrorOpenSettlementWithUpperLimit";
import ErrorPixKeyIncorrect from "../pages/Errors/ErrorPixKeyIncorrect";
import ErrorOldDocument from "../pages/Errors/CAF/ErrorOldDocument";
import ErrorUnderageCustomer from "../pages/Errors/CAF/ErrorUnderageCustomer";
import ContractVivoPayAwardViewer from "../pages/ContractVivoPayAwardViewer";
import LackPeriod from "../pages/Feedbacks/LackPeriod";
import OnlyOneOperationAllowedAnnually from "../pages/Feedbacks/OneOperationAllowedAnually";
import IsOffFGTS from "../pages/Feedbacks/IsOffFGTS";

export const routes: RouteObject[] = [
	// Rotas publicas
	{
		element: <PublicRoute />,
		children: [
			{
				path: "/",
				element: <Home />,
			},
			{
				path: "/login",
				element: <Authentication />,
			},
			{
				path: "/sign-in-info",
				element: <SignInInfo />,
			},
			{
				path: "/simulator-lead",
				element: <SimulatorLead />,
			},
			{
				path: "/how-to-authorize",
				element: <HowToAuthorize />,
			},
			{
				path: "/simulator-resume",
				element: <SimulatorResume />,
			},
			{
				path: "/expired-token",
				element: <ExpiredToken />,
			},
			{
				path: "/fintech-registration/terms-of-conditions",
				element: <TermsOfConditions />,
			},
			{
				path: "/access-blocked",
				element: <AccessBlocked />,
			},
			{
				path: "/system-maintenance",
				element: <SystemMaintenance />,
			},
			{
				path: "/customer-refusal",
				element: <CustomerRefusal />,
			},
			{
				path: "/error/:type",
				element: <ErrorCustomUnavailable />,
			},
			{
				path: "/error-open-settlement-with-upper-limit",
				element: <ErrorOpenSettlementWithUpperLimit />,
			},
			{
				path: "/underage-costumer",
				element: <ErrorUnderageCustomer />,
			},
			{
				path: "/lack-period",
				element: <LackPeriod />,
			},
			{
				path: "/one-operation-allowed-anually",
				element: <OnlyOneOperationAllowedAnnually />,
			},
			{
				path: "/fgts-indisponivel",
				element: <IsOffFGTS />,
			},
		],
	},
	// Rotas privadas
	{
		element: <ProtectedRoute />,
		children: [
			{
				path: "/home-logged",
				element: <HomeLogged />,
			},
			{
				path: "/call-center",
				element: <CallCenter />,
			},
			{
				path: "/list-of-contracts",
				element: <ListOfContracts />,
			},
			{
				path: "/contract",
				element: <ContractDetails />,
			},
			{
				path: "/anniversary-membership-egress",
				element: <AnniversaryMembershipEgress />,
			},
			{
				path: "/caixa-error",
				element: <CaixaError />,
			},
			{
				path: "/inexistent-anniversary-membership",
				element: <InexistentAnniversaryMembership />,
			},
			{
				path: "/ongoing-operation",
				element: <OngoingOperation />,
			},
			{
				path: "/on-locked-data-range",
				element: <OnLockedDateRange />,
			},
			{
				path: "/processing-pending-changes",
				element: <ProcessingPendingChanges />,
			},
			{
				path: "/unauthorized-institution",
				element: <UnauthorizedInstitution />,
			},
			{
				path: "/unavailable-real-time",
				element: <UnavailableRealTime />,
			},
			{
				path: "/connect-fgts-balance",
				element: <ConnectFGTSBalance />,
			},
			{
				path: "/simulator-summary",
				element: <SimulatorSummary />,
			},
			{
				path: "/anticipation",
				element: <Anticipation />,
			},
			{
				path: "/authorization-inquiry-balance",
				element: <AuthorizationInquiryBalance />,
			},
			{
				path: "/withdraw-resume",
				element: <WithdrawResume />,
			},
			{
				path: "/contract-viewer",
				element: <ContractViewer />,
			},
			{
				path: "/withdraw-payment-info",
				element: <WithdrawPaymentInfo />,
			},
			{
				path: "/system-unavailable",
				element: <SystemUnavailable />,
			},
			{
				path: "/sign-contract/forgot-password/password-reset",
				element: <PasswordReset />,
			},
			{
				path: "/sign-contract/forgot-password/success-alter-password",
				element: <SuccessAlterPassword />,
			},
			{
				path: "/password-change-success",
				element: <PasswordChangeSuccess />,
			},
			{
				path: "/sign-contract",
				element: <SignContract />,
			},
			{
				path: "/anticipation-finished",
				element: <AnticipationFinished />,
			},
			{
				path: "/fintech-registration/register-success",
				element: <RegisterSuccess />,
			},
			{
				path: "/fintech-registration/validate-token-otp-email",
				element: <ValidateTokenOTPByEmail />,
			},
			{
				path: "/fintech-registration/password-registration",
				element: <PasswordRegistration />,
			},
			{
				path: "/fintech-registration/personal-aditional-info",
				element: <PersonalAditionalInfo />,
			},
			{
				path: "/fintech-registration/address",
				element: <AddressInput />,
			},
			{
				path: "/fintech-registration/user-registration-data",
				element: <UserRegistrationData />,
			},
			{
				path: "/fintech-registration/validate-documents/home",
				element: <ValidateDocumentsHome />,
			},
			{
				path: "/fintech-registration/validate-documents/under-analysis",
				element: <ValidateDocumentsUnderAnalysis />,
			},
			{
				path: "/fintech-registration/validate-documents/approved",
				element: <ValidateDocumentsApproved />,
			},
			{
				path: "/fintech-registration/validate-documents/refused",
				element: <ValidateDocumentsRefused />,
			},
			{
				path: "/sign-contract/forgot-password/validate-otp-by-sms",
				element: <ValidateOTPBySMS />,
			},
			{
				path: "/fraud-analysis",
				element: <OnboardingCaf />,
			},
			{
				path: "/error-query-time-expired",
				element: <ErrorQueryTimeExpired />,
			},
			{
				path: "/error-pix-key-incorrect",
				element: <ErrorPixKeyIncorrect />,
			},
			{
				path: "/error-old-document",
				element: <ErrorOldDocument />,
			},
			{
				path: "/contract-vivo-pay-award-viewer",
				element: <ContractVivoPayAwardViewer />,
			},

		],
	},
];
